<template>
  <div class="image" :style="`background-image: url(${image});`"/>
</template>

<script>
export default {
  props: {
    image: {
      type: String,
      default: '',
    }
  },
}
</script>

<style lang="scss">
.image {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: 50% 0;
}
</style>



// WEBPACK FOOTER //
// AsideImage.vue?e9ba32f0